import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

interface UseNoteCardStylesProps {
  hasNotes: boolean;
}

export const useNotesCardStyles = makeStyles<Theme, UseNoteCardStylesProps>(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    marginBottom: '1rem'
  },
  card: {
    background: 'white',
    width: '100%',
    borderRadius: '4px'
  },
  title: {
    padding: '1rem',
    borderBottom: `1px solid ${Colors.lightGray}`
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'centre'
  },
  wrapper: {
    position: 'relative',
    minHeight: (props) => (props.hasNotes ? 0 : '200px')
  }
}));
